"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  oneOfFieldsIsRequired: 'One of the fields is required',
  fieldCannotBeEmpty: 'Field cannot be empty',
  mustBeNumber: 'Field must be a number'
};